import React from 'react'
import UIButton from '@ui/Button'

export default function Button({ onClick, disabled, icon, inactive }) {
  return (
    <UIButton
      onClick={onClick}
      disabled={disabled}
      size='big'
      className='counter-input-button'
      inactive={inactive}
      icon={icon}
    />
  )
}
